/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/SRISlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.sri || initialState;

export const selectSRICardLoading = createSelector([selectDomain], (state) => state.cardLoading);
export const selectSRICardData = createSelector([selectDomain], (state) => state.cardDetails);
export const selectSRITabs = createSelector([selectDomain], (state) => state.tabs);
export const userScoreLoading = createSelector([selectDomain], (state) => state.userScoreLoading);
export const selectUserScore = createSelector([selectDomain], (state) => state.userScore);
export const selectUserScoreGroup = createSelector([selectDomain], (state) => state.userScoreGraph);

export const selectCompanyGraph = createSelector(
  [selectDomain],
  (state) => state.companyViewGraph,
);
export const selectPeopleGraph = createSelector(
  [selectDomain],
  (state) => state.peopleViewGraph,
);

export const selectArticleGraph = createSelector(
  [selectDomain],
  (state) => state.articleViewGraph,
);
export const selectSessionGraph = createSelector(
  [selectDomain],
  (state) => state.sessionViewGraph,
);
export const selectEmailOpenGraph = createSelector(
  [selectDomain],
  (state) => state.emailOpenGraph,
);

export const selectPeopleGraphLoading = createSelector(
  [selectDomain],
  (state) => state.peopleGraphLoading,
);
export const selectCompanyGraphLoading = createSelector(
  [selectDomain],
  (state) => state.companyGraphLoading,
);
export const selectArticleGraphLoading = createSelector(
  [selectDomain],
  (state) => state.articleGraphLoading,
);
export const selectSessionGraphLoading = createSelector(
  [selectDomain],
  (state) => state.sessionGraphLoading,
);
export const selectEmailOpenGraphLoading = createSelector(
  [selectDomain],
  (state) => state.emailOpenGraphLoading,
);
export const selectTeamLeaderBoardLoading = createSelector(
  [selectDomain],
  (state) => state.teamLeaderBoardLoading,
);
export const selectTeamLeaderBoardGraph = createSelector(
  [selectDomain],
  (state) => state.teamLeaderBoardGraph,
);
export const selectLeaderBoardSummaryLoading = createSelector(
  [selectDomain],
  (state) => state.leaderBoardSummaryLoading,
);
export const selectLeaderBoardSummaryGraph = createSelector(
  [selectDomain],
  (state) => state.leaderBoardSummaryGraph,
);
export const selectOverviewFilter = createSelector(
  [selectDomain],
  (state) => state.filters,
);
export const selectOverviewFilterType = createSelector(
  [selectDomain],
  (state) => state.filtersType,
);

export const selectTeamReadinessFiltersLoading = createSelector(
  [selectDomain],
  (state) => state.teamReadinessFiltersLoading,
);

export const selectTeamReadinessFilterDetails = createSelector(
  [selectDomain],
  (state) => state.teamReadinessFilterDetails,
);

export const selectTeamReadinessFiltersData = createSelector(
  [selectDomain],
  (state) => state.teamReadinessFiltersData,
);
export const selectTeamReadinessRegions = createSelector(
  [selectDomain],
  (state) => state.teamReadinessRegions,
);
export const selectTeamReadinessTeams = createSelector(
  [selectDomain],
  (state) => state.teamReadinessTeams,
);
export const selectTeamReadinessSelectedRegion = createSelector(
  [selectDomain],
  (state) => state.teamReadinessSelectedRegion,
);
export const selectedTeamSRI = createSelector(
  [selectDomain],
  (state) => state.teamReadinessSelectedTeam,
);

export const selectTeamReadinessBeltsLoading = createSelector(
  [selectDomain],
  (state) => state.teamReadinessBeltsLoading,
);

export const selectTeamReadinessBeltsGraph = createSelector(
  [selectDomain],
  (state) => state.teamReadinessBeltsGraph,
);

export const selectTeamReadinessAvgLoading = createSelector(
  [selectDomain],
  (state) => state.teamReadinessAvgLoading,
);

export const selectTeamReadinessAvgGraph = createSelector(
  [selectDomain],
  (state) => state.teamReadinessAvgGraph,
);

export const selectTeamReadinessTeamRankLoading = createSelector(
  [selectDomain],
  (state) => state.teamReadinessTeamRankLoading,
);

export const selectTeamReadinessTeamRankData = createSelector(
  [selectDomain],
  (state) => state.teamReadinessTeamRankData,
);

export const selectLeaderBoardSelectedRegion = createSelector(
  [selectDomain],
  (state) => state.leaderBoardSelectedRegion,
);
export const selectLeaderBoardSelectedTeam = createSelector(
  [selectDomain],
  (state) => state.leaderBoardSelectedTeam,
);

export const selectSRISelectedUserId = createSelector(
  [selectDomain],
  (state) => state.selectedUserId,
);
export const selectSRISelectedUser = createSelector(
  [selectDomain],
  (state) => state.selectedUser,
);
export const selectPopup = createSelector(
  [selectDomain],
  (state) => state.addCompanyPopup,
);

export const selectSalesSigmaLoading = createSelector(
  [selectDomain],
  (state) => state.salesSigmaLoading,
);

export const selectSalesSigmaLoaded = createSelector(
  [selectDomain],
  (state) => state.salesSigmaLoaded,
);

export const selectSalesSigmaData = createSelector(
  [selectDomain],
  (state) => state.salesSigmaData,
);
export const existingPersonId = createSelector(
  [selectDomain],
  (state) => state.cardDetails.personId,
);

export const selectComplianceData = createSelector(
  [selectDomain],
  (state) => state.complianceData,
);

export const selectComplianceDataLoading = createSelector(
  [selectDomain],
  (state) => state.complianceDataLoading,
);

export const selectComplianceExportLoading = createSelector(
  [selectDomain],
  (state) => state.complianceExportLoading,
);

export const selectCompanyOverviewEngagement = createSelector(
  [selectDomain],
  (state) => state.overviewCompanyEngagement,
);

export const selectPersonOverviewEngagement = createSelector(
  [selectDomain],
  (state) => state.overviewPersonEngagement,
);

export const selectAlertOverviewEngagement = createSelector(
  [selectDomain],
  (state) => state.overviewAlertEngagement,
);

export const selectMyEngagementHeadersContainerCompanies = createSelector(
  [selectDomain],
  (state) => state.myEngagementDetailsCompany.header_containers,
);

export const selectMyEngagementHeadersContainerPeople = createSelector(
  [selectDomain],
  (state) => state.myEngagementDetailsPeople.header_containers,
);
export const selectMyEngagementHeadersContainerAlerts = createSelector(
  [selectDomain],
  (state) => state.myEngagementDetailsAlert.header_containers,
);

export const selectMyEngagementDetailContainerCompanies = createSelector(
  [selectDomain],
  (state) => state.myEngagementDetailsCompany.detail_containers,
);

export const selectMyEngagementDetailContainerPeople = createSelector(
  [selectDomain],
  (state) => state.myEngagementDetailsPeople.detail_containers,
);

export const selectMyEngagementDetailContainerAlerts = createSelector(
  [selectDomain],
  (state) => state.myEngagementDetailsAlert.detail_containers,
);

export const selectCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.overviewCompanyEngagementLoading,
);

export const selectPeopleLoading = createSelector(
  [selectDomain],
  (state) => state.overviewPersonEngagementLoading,
);

export const selectAlertsLoading = createSelector(
  [selectDomain],
  (state) => state.overviewAlertsEngagementLoading,
);

export const selectCompanyFetchMoreLoading = createSelector(
  [selectDomain],
  (state) => state.overviewEngagementFetchMoreCompanyLoading,
);

export const selectPeopleFetchMoreLoading = createSelector(
  [selectDomain],
  (state) => state.overviewEngagementFetchMorePersonLoading,
);

export const selectMyEngagaementCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.myEngagementCompanyLoading,
);

export const selectMyEngagaementPeopleLoading = createSelector(
  [selectDomain],
  (state) => state.myEngagementPersonLoading,
);

export const selectMyEngagaementAlertsLoading = createSelector(
  [selectDomain],
  (state) => state.myEngagementAlertLoading,
);

export const selectUserCompanyFetchMoreLoading = createSelector(
  [selectDomain],
  (state) => state.myEngagementFetchMoreCompanyLoading,
);

export const selectUserPeopleFetchMoreLoading = createSelector(
  [selectDomain],
  (state) => state.myEngagementFetchMorePersonLoading,
);

export const selectUserAlertFetchMoreLoading = createSelector(
  [selectDomain],
  (state) => state.myEngagementFetchMoreAlertLoading,
);

export const selecthasMoreCompany = createSelector(
  [selectDomain],
  (state) => state.hasMoreCompany,
);

export const selecthasMorePeople = createSelector(
  [selectDomain],
  (state) => state.hasMorePeople,
);

export const selecthasMoreAlert = createSelector(
  [selectDomain],
  (state) => state.hasMoreAlert,
);
